import { render, staticRenderFns } from "./FrozenOutline.vue?vue&type=template&id=4f83f606&"
import script from "./FrozenOutline.vue?vue&type=script&lang=ts&"
export * from "./FrozenOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports